export default "__VITE_ASSET__6e2e90eb__"